export class TrackingEvent {
    CategoryEvent?: string;
    LabelEvent?: string;
    ActionEvent?: string;
    PositionEvent?: string;
    LocationEvent?: string;
    EventDetails?: string;
    UrlClicked?: string;
    PageName?: string;
    SiteSection?: string;
    RefferingAction?: string;
    Value?: number | string | null;
    RegistrationType?: string | null;
    Product?: string;
    HccCategory?: string | null;
    HccArticle?: string | null;
    AffordabilityJourney?: string | null;
    ContentPosition?: number | string | null;
    RegistrationSourcePath?: string | null;
    Progress?: string;
    KycVerifcationProcess?: string;
    LimitDetails?: string;
    UserAccountId?: string | null;
    offerId?: string | null;
    type?: string | null;
    flowName?: string | null;
    AffordabilityGroups?: string | null;
    AffLimitType?: string | null;
    AffAgeGroups?: string | null;
}

export const EventNameConst = {
    HelpAndContact: 'Event.HCC',
    Tracking: 'Event.Tracking',
    Value: 'Event.Value',
    ContentView: 'contentView',
    AccountOptions: 'Event.AccountOptions',
    Kyc: 'Event.KYC',
};

export class ErrorDetail {
    [key: string]: string | number | undefined;
}

export const TrackingConstants: { [key: string]: string } = {
    COMPONENT_CATEGORY_EVENT: 'component.CategoryEvent',
    COMPONENT_LABEL_EVENT: 'component.LabelEvent',
    COMPONENT_ACTION_EVENT: 'component.ActionEvent',
    COMPONENT_POSITION_EVENT: 'component.PositionEvent',
    COMPONENT_LOCATION_EVENT: 'component.LocationEvent',
    COMPONENT_EVENT_DETAILS: 'component.EventDetails',
    COMPONENT_URL_CLICKED: 'component.URLClicked',
};

export const TrackingConstantsV2: { [key: string]: string } = {
    CATEGORY_EVENT: 'CategoryEvent',
    LABEL_EVENT: 'LabelEvent',
    ACTION_EVENT: 'ActionEvent',
    POSITION_EVENT: 'PositionEvent',
    LOCATION_EVENT: 'LocationEvent',
    EVENT_DETAILS: 'EventDetails',
    URL_CLICKED: 'UrlClicked',
    FLOWNAME_EVENT: 'flowName',
};

export type TrackingConstantsType = (typeof TrackingConstants)[keyof typeof TrackingConstants];

export enum FieldEvent {
    Click = 'click',
    Blur = 'blur',
    Error = 'error',
}

export enum TrackingActionEvents {
    LOAD = 'load',
    CLICK = 'click',
    SUCCESS = 'success',
    ERROR = 'error',
}

export enum SelfieScreenLocations {
    VERIFY_LOCATION = 'verifying your location',
    TAKE_SELFIE = 'take your selfie',
    SPORTSBOOK_LOCATOR = 'sports book locator screen',
    ID_VS_SELFIE_VERIFICATION_IN_PROGRESS = 'agent ID vs selfie verification in progress',
    SCAN_COMPLETE = 'selfie flow scan complete',
    SELFIE_MANUAL_CAPTURE = 'Selfie flow manual capture',
    SELFIE_ERROR = 'Selfie flow error',
    MAX_TRIES_EXHAUSTED = 'Selfie flow max retries exhausted',
    LOADING_SCREEN = 'Loding screen',
    SELFIE_VERIFICATION_FAILED = 'we could not verify your selfie',
    REVIEWING_YOUR_INFO = 'We are reviewing your info',
}

export enum PositionEvents {
    NOT_APPLICABLE = 'not applicable',
    SELFIE_VERIFICATION = 'selfie verification',
    ADDRESS_LIST_FULL = 'address list full',
}

export enum UrlClickedConst {
    NOT_APPLICABLE = 'not applicable',
    HOME = 'home',
    ADDRESS_FINDER = 'address finder',
    SELFIE_FLOW = 'selfie capture',
}

export interface ISelfieFlowTrackingEventMap {
    [key: string]: ISelfieFlowTrackingCommonEvent;
}

export interface ISelfieFlowTrackingCommonEvent {
    LabelEvent: string;
    ActionEvent: string;
    PositionEvent: string;
    LocationEvent: string;
}

export enum IDVerificationScreenNames {
    UploadIDScreen = 'Upload Your ID',
    ConsentScreen = 'privacy consent',
    ScanBackIdScreen = 'scan back of ID prompt screen',
    OCRDetailsScreen = 'review document details',
    OCRErrorScreen = 'review document details- error screen',
    PleaseCheckYourIDScreen = 'Please check your ID',
    IncodeScanFrontIDScreen = 'scan front of ID',
    IncodeScanBackIDScreen = 'scan back of ID',
    ManualScanFrontIDScreen = 'manual- scan front of ID',
    ManualScanBackIDScreen = 'manual- scan back of ID',
    ScanAttemptFailureScreen = 'failed ID scan attempt screen',
    IDUploadFailedWithMissingInfo = 'review document edit details',
}

export interface IIdVerificationTrackingEventMap {
    ActionEvent: string;
    LocationEvent: string;
}

export enum SelfieFlowTrackingEventKey {
    LoadingScreen = 'LoadingScreen',
    UserLocationVerified = 'UserLocationVerified',
    UserLocationNotVerified = 'UserLocationNotVerified',
    UserLandingOnAddressListPage = 'UserLandingOnAddressListPage',
    UserLandingOnTakeSelfiePage = 'UserLandingOnTakeSelfiePage',
    UserNotWithinResort = 'UserNotWithinResort',
    IncodeSelfieAndIdOnbordingError = 'IncodeSelfieAndIdOnbordingError',
    ErrorWhileFetchingUsersLocation = 'ErrorWhileFetchingUsersLocation',
    TakeSelfieBtnClick = 'TakeSelfieBtnClick',
    SportsBookLocatorBtnClick = 'SportsBookLocatorBtnClick',
    ResortAddressClicked = 'ResortAddressClicked',
    ResortAddressClickedInSelfie = 'ResortAddressClickedInSelfie',
    BackClickedFromAddressPage = 'BackClickedFromAddressPage',
    BackClickedFromTakeSelfiePage = 'BackClickedFromTakeSelfiePage',
    ViewSuccessHandlerScreen = 'ViewSuccessHandlerScreen',
    SuccessHandlerScreenBtnClick = 'SuccessHandlerScreenBtnClick',
    SuccessCapture = 'SuccessCapture',
    // FaceNotDetected = 'FaceNotDetected',
    SpoofAttempt = 'SpoofAttempt',
    NoAttemps = 'NoAttemps',
    HeaderBarCTAFromSelfieErrorScreen = 'HeaderBarCTAFromSelfieErrorScreen',
    HeaderBarCTALoadingScreen = 'HeaderBarCTALoadingScreen',
    HeaderBarCTAFromAddressPage = 'HeaderBarCTAFromAddressPage',
    HeaderBarCTAFromTakeSelfiePage = 'HeaderBarCTAFromTakeSelfiePage',
    HeaderBarCTAFromReviewingYourInfo = 'HeaderBarCTAFromReviewingYourInfo',
    CouldNotVerifyYourSelfie = 'CouldNotVerifyYourSelfie',
}

export enum LabelEventKeys {
    INCODE = 'incode',
    SELFIE_AUTHENTICATION = 'selfie authentication',
    GEO_LOCATION = 'geo location',
}

export enum ToasterQueueMessages {
    RegAccountCreatedSuccessfully = 'RegAccountCreatedSuccessfully',
    UserNotWithinResort = 'UserNotWithinResort',
    GDSLocationFetchError = 'GDSLocationFetchError',
    AccountCreatedSuccssfully = 'AccountCreatedSuccssfully',
    IncodeSelfieAndIdOnbordingError = 'IncodeSelfieAndIdOnbordingError',
    IncodeDocumentVerificationSuccess = 'IncodeDocumentVerificationSuccess',
    IncodeIDUploadFailedWithMissingInfo = 'IncodeIDUploadFailedWithMissingInfo',
    IncodeSelfieVerificationSuccess = 'IncodeSelfieVerificationSuccess',
}

export enum HeaderBarCTA {
    BackBtn = 'Back Button',
    CloseBtn = 'X Close Button',
}
